var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew250({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 3,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.77,5.81H4.06V5.19H8.23v.62H6.51v5H5.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.71,9.94A2.62,2.62,0,0,0,10,10.3c.74,0,1.18-.39,1.18-1s-.3-.83-1.07-1.12c-.92-.32-1.48-.8-1.48-1.6a1.62,1.62,0,0,1,1.82-1.53,2.54,2.54,0,0,1,1.24.28l-.2.59a2.25,2.25,0,0,0-1.07-.26c-.77,0-1.06.46-1.06.84,0,.53.34.79,1.12,1.09,1,.37,1.44.83,1.44,1.65s-.64,1.63-2,1.63a2.9,2.9,0,0,1-1.44-.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew250);
export default __webpack_public_path__ + "static/media/Symbolpack_New_250.d0e2f7f59c0c80d5c7aa8b7b3ec01e3a.svg";
export { ForwardRef as ReactComponent };